@if (reviewerSession && selectedPersona) {
  <div class="reviewers-details">
    <div>
      <button mat-button (click)="showView()">&lt; All Reviewers</button>
    </div>
    <div class="reviewers-details__header">
      <h3 class="reviewers-details__title">{{ reviewerSession.document }}</h3>
      <p class="reviewers-details__meta">Reviewed by {{ selectedPersona.name }} on {{ reviewerSession.created_at | date: 'yyyy-MM-dd' }}</p>
    </div>
    
    <!-- Overview section with suggestion counts -->
    <div class="overview u-margin-left u-margin-bottom">
      <h3 class="overview__title">Review Progress</h3>
      <div class="overview__stats">
        <div class="overview__stat-item">
          <span class="overview__count overview__count--unresolved">{{ getUnresolvedCount() }}</span>
          <span class="overview__label">Unresolved</span>
        </div>
        <div class="overview__stat-item">
          <span class="overview__count overview__count--resolved">{{ getResolvedCount() }}</span>
          <span class="overview__label">Resolved</span>
        </div>
        <div class="overview__stat-item">
          <span class="overview__count overview__count--total">{{ getTotalCount() }}</span>
          <span class="overview__label">Total</span>
        </div>
        <div class="overview__progress-container">
          <div class="overview__progress-bar" [style.width.%]="getResolvedCount() / getTotalCount() * 100"></div>
        </div>
      </div>
    </div>
    
    <mat-accordion>
      @for (theme of (filteredThemes | async) || []; track $index; let themeIdx = $index) {
        @for (review of theme.reviews.oppose; track $index; let reviewIdx = $index) {
          @if (!review.resolved) {
          <mat-expansion-panel class="panel--unresolved" [attr.data-test-id]="'reviewers-unresolved-panel-' + themeIdx + '-' + reviewIdx"> 
            <mat-expansion-panel-header collapsedHeight="auto" expandedHeight="auto">
              <div class="panel__header-content layout layout--column">
                <span class="panel__theme"><mat-icon class="panel__theme-icon">lightbulb</mat-icon><b>{{ theme.theme }}</b></span>
                <span class="panel__example">{{themeIdx + 1}}-{{ reviewIdx + 1 }}: {{ review.example }}</span>
              </div>
            </mat-expansion-panel-header>
              <div class="u-margin-bottom">
                <h3 class="u-padding-top recommendation__title">Recommendation:</h3>
                <div class="recommendation__container">
                  <p class="recommendation__text">
                    {{ review.suggestion }}
                  </p>
                  <!-- TODO: Add notes section?-->
                  <!-- <div class="notes">
                    <mat-form-field appearance="outline" class="notes__field">
                      <mat-label>Notes</mat-label>
                      <textarea 
                        matInput 
                        [(ngModel)]="review.notes" 
                        placeholder="Add notes about this issue..."
                        cdkTextareaAutosize
                        #autosize="cdkTextareaAutosize"
                        cdkAutosizeMinRows="2"
                        cdkAutosizeMaxRows="5"
                      ></textarea>
                      <mat-icon matSuffix *ngIf="review.notes" (click)="saveNotes()" class="notes__save-icon">save</mat-icon>
                    </mat-form-field>
                  </div> -->
                  <div class="recommendation__actions">
                    <button mat-button class="action-button" (click)="toClipboard(review.suggestion)">
                      <mat-icon>content_copy</mat-icon>
                      Copy
                    </button>
                    <!-- TODO: Add dismiss button?-->
                    <!-- <button mat-button class="action-button">
                      <mat-icon>remove</mat-icon>
                      Dismiss
                    </button>                     -->
                    <button mat-button class="action-button" (click)="toggleTheme(themeIdx, reviewIdx)">
                      <mat-icon>check</mat-icon>
                      Resolve
                    </button>
                  </div>
                </div>
              </div>
            </mat-expansion-panel>
          }
        }
      }
    </mat-accordion>
    <div class="layout__bottom">
      <h3 class="u-margin-left u-padding-top-lg">Resolved Issues</h3>
      <mat-accordion>
        @for (theme of (filteredThemes | async) || []; track $index; let themeIdx = $index) {
          @for (review of theme.reviews.oppose; track $index; let reviewIdx = $index) {
            @if (review.resolved) {
            <mat-expansion-panel class="panel--resolved">
              <mat-expansion-panel-header collapsedHeight="auto" expandedHeight="auto">
                <div class="panel__header-content layout layout--column">
                  <span class="panel__theme"><mat-icon class="panel__theme-icon">lightbulb</mat-icon><b>{{ theme.theme }}</b></span>
                  <span class="panel__example">{{ themeIdx + 1 }}-{{ reviewIdx + 1 }}: {{ review.example }}</span>
                </div>
              </mat-expansion-panel-header>
                <div class="u-margin-bottom">
                  <h3 class="u-padding-top recommendation__title">Recommendation:</h3>
                  <div class="recommendation__container">
                    <p class="recommendation__text">
                      {{ review.suggestion }}
                    </p>
                    <!-- <div class="notes">
                      <mat-form-field appearance="outline" class="notes__field">
                        <mat-label>Notes</mat-label>
                        <textarea 
                          matInput 
                          [(ngModel)]="review.notes" 
                          placeholder="Add notes about this issue..."
                          cdkTextareaAutosize
                          #autosize="cdkTextareaAutosize"
                          cdkAutosizeMinRows="2"
                          cdkAutosizeMaxRows="5"
                          [readonly]="true"
                        ></textarea>
                      </mat-form-field>
                    </div> -->
                    <div class="recommendation__actions">
                      <button mat-button class="action-button" (click)="toClipboard(review.suggestion)">
                        <mat-icon>content_copy</mat-icon>
                        Copy
                      </button>
                      <button mat-button class="action-button" (click)="toggleTheme(themeIdx, reviewIdx)">
                        <mat-icon>undo</mat-icon>
                        Unresolve
                      </button>
                    </div>
                  </div>
                </div>
              </mat-expansion-panel>
            }
          }
        }
      </mat-accordion>
    </div>
  </div>
}
